import React from 'react'

// Components
import Error from './error'

// Libs
import classnames from 'classnames'

// Material UI
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

const CustomSelect = ({
  items,
  name,
  onBlur,
  errors,
  value,
  onChange,
  placeholder,
}) => {
  let classes = classnames('form-input', 'select-input', {
    error: errors && errors.length,
  })
  return (
    <>
      <div className={classes}>
        <Select
          name={name}
          disableUnderline
          onBlur={onBlur}
          className="w-full transition duration-700 focus:bg-white focus:text-black"
          value={value}
          onChange={onChange}
          displayEmpty
        >
          <MenuItem value="" disabled>
            <div className="text-left text-grayText placeholders">
              {placeholder}
            </div>
          </MenuItem>
          {items}
        </Select>
      </div>
      {errors && errors.map((e, i) => <Error key={i} index={i} message={e} />)}
    </>
  )
}

export default CustomSelect
